import React from 'react';
import { Image, ScrollView, StyleSheet, Text, View } from '../base_components';

import BusyComponent from '../busy_component';
import MenuButton from '../buttons/menu_button';
import WideButton from '../buttons/wide_button';
import ModalDialog from '../dialogs/modal_dialog';
import ProgressSpinner from '../progress_spinner';

import Analytics from '../../tools/analytics';
import CounterStore from '../../stores/counter_store';
import UserStore from '../../stores/user_store';

const styles = StyleSheet.create({
  promoAbridgedScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  scrollInner: {
    paddingBottom: 50,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflowY: 'scroll',
  },
  topSpacer: {
    height: '4em',
  },
  afterIframeSpacer: {
    height: '2em',
  },
  text: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '2em',
    color: 'white',
    fontSize: '1.1em',
    textAlign: 'center',
  },
  italics: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '2em',
    marginTop: '2em',
    color: 'white',
    fontSize: '1em',
    fontFamily: 'San Fransisco,Roboto,sans',
    fontStyle: 'italic',
    textAlign: 'center',
  },
  logos: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '3em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    marginLeft: '1em',
    marginRight: '1em',
    padding: '0.5em',
    backgroundColor: 'white',
    borderRadius: '0.5em',
  },
  abridged: {
    width: '14em',
    height: '4em',
  },
  ethereum: {
    width: '4em',
    height: '4em',
  },
});

const ABRIDGED_IMG =
  'https://cdn.harbor.lol/assets/70d88474497900bff78bdb05064c86d7';
const ETHEREUM_IMG =
  'https://cdn.harbor.lol/assets/832b60ab39e8279bc738bde059b098dc';

type Props = {};
type State = {
  is_logged_in: boolean;
  is_loading: boolean;
  next_claim_time: number;
};

export default class PromoAbridgedScreen extends BusyComponent<Props, State> {
  state = {
    is_logged_in: UserStore.isLoggedIn(),
    is_loading: true,
    next_claim_time: 0,
  };
  componentDidMount() {
    CounterStore.addChangeListener(this._onCounterUpdate);
    if (UserStore.isLoggedIn()) {
      CounterStore.fetchCounter('ad_abridged1');
    }
    Analytics.showScreen('promo_abridged1');
  }
  componentWillUnmount() {
    CounterStore.removeChangeListener(this._onCounterUpdate);
  }
  _onCounterUpdate = () => {
    const count = CounterStore.getCount('ad_abridged1');
    if (count !== undefined) {
      if (count > 0) {
        const next_claim_time = CounterStore.getResetTime('ad_abridged1');
        this.setState({ is_loading: false, next_claim_time });
      } else {
        this.setState({ is_loading: false, next_claim_time: 0 });
      }
    }
  };

  _onLoginPress = () => {
    if (this.setBusy()) {
      UserStore.login(err => {
        this.clearBusy();
        if (err) {
          ModalDialog.error('Login Failed.');
        } else {
          this.setState({ is_logged_in: true });
          CounterStore.fetchCounter('ad_abridged1');
        }
      });
    }
  };

  _onPress = () => {
    _doAbridged();
  };

  render() {
    const { is_logged_in, is_loading, next_claim_time } = this.state;

    let content = null;
    if (true) {
      content = (
        <>
          <Text style={styles.text}>Sorry, all sold out!</Text>
        </>
      );
    } else if (!is_logged_in) {
      content = (
        <>
          <WideButton text='Login' onPress={this._onLoginPress} />
        </>
      );
    } else if (is_loading) {
      content = (
        <>
          <ProgressSpinner />
        </>
      );
    } else if (next_claim_time > 0) {
      content = (
        <>
          <Text style={styles.text}>Come back tomorrow to get more coins!</Text>
        </>
      );
    } else {
      content = (
        <>
          <WideButton text='Get Coins' onPress={this._onPress} />
        </>
      );
    }

    return (
      <View style={styles.promoAbridgedScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <View style={styles.topSpacer} />
          <iframe
            title='youtube'
            src='https://www.youtube.com/embed/3SvXYLR1tQw'
            frameborder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowfullscreen
          ></iframe>
          <View style={styles.afterIframeSpacer} />
          <Text style={styles.text}>
            Login with us to Win a Dank hoodie.  Everyone wins something.
            Click on the link below.
          </Text>
          <Text style={styles.text}>
            Learn more about the block chain and Abridged below.
          </Text>
          <View style={styles.logos}>
            <a
              href='https://docs.ethhub.io/ethereum-basics/what-is-ethereum/'
              target='_blank'
            >
              <View style={styles.imageWrapper}>
                <Image style={styles.ethereum} source={ETHEREUM_IMG} />
              </View>
            </a>
            <a href='https://abridged.io' target='_blank'>
              <View style={styles.imageWrapper}>
                <Image style={styles.abridged} source={ABRIDGED_IMG} />
              </View>
            </a>
          </View>
          {content}
          <Text style={styles.italics}>
            Limited time offer. Daily limit of 1500 Dank Coin per day while
            supplies last.
          </Text>
        </ScrollView>
        <MenuButton />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function _doAbridged() {
  Analytics.promoClick('promo_abridged1');

  const player_id = UserStore.getPlayerData().player_id;
  window.location.replace(
    `https://kedn0ap7li.execute-api.us-east-2.amazonaws.com/prod/dank-airdrop?player_id=${player_id}`
  );
}
